import { Text } from "@/elements"
import clsx from "clsx"
import React from "react"

interface Props {
  innerClassName?: string
  variant?: "default" | "transparent"
}

export const ProBadge: React.FC<Props> = ({ innerClassName = "", variant = "transparent" }) => {
  const isTransparent = variant === "transparent"

  if (isTransparent) {
    return (
      <div className="relative inline-block inline-flex rounded-full p-[2px]">
        <div className="bg-pro-gradient mask-border pointer-events-none absolute inset-0 rounded-full p-[1px]" />
        <div
          className={clsx("relative z-10 inline-block rounded-full bg-transparent px-[10px] py-[1px]", innerClassName)}>
          <Text className="text-pro-gradient-dark">Pro</Text>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-pro-gradient inline-block rounded-full">
      <div
        className={clsx("relative inline-block rounded-full bg-bg-1 px-[10px] py-[1px]", innerClassName)}
        style={{
          border: "2px solid transparent",
          backgroundClip: "padding-box",
        }}>
        <Text className="text-pro-gradient-dark">Pro</Text>
      </div>
    </div>
  )
}
